import React, { useState, useEffect, useRef } from 'react'
import { gsap } from 'gsap'
import { TiChevronLeftOutline } from "react-icons/ti";
import { TiChevronRightOutline } from "react-icons/ti";
import {v4 as uuidv4} from 'uuid'
export default function Carousel() {

    const initialImgArray = [
        {
            id: 1,
            name: "img1",
            current: "show",
            src: "https://www.mife90.org/lexpedition/carousel_eXP/Assets/photo_1.JPG"
        },
        {
            id: 2,
            name: "img2",
            current: "hide",
            src: "https://www.mife90.org/lexpedition/carousel_eXP/Assets/photo_2.JPG"
        },
        {
            id: 3,
            name: "img3",
            current: "hide",
            src: "https://www.mife90.org/lexpedition/carousel_eXP/Assets/photo_3.JPG"
        },
        {
            id: 4,
            name: "img4",
            current: "hide",
            src: "https://www.mife90.org/lexpedition/carousel_eXP/Assets/photo_4.JPG"
        },
       
    ]
    
    const [imgArray, setImgArray] = useState(initialImgArray)

   
    const tmpImgArray = [...imgArray]


    var numSlides = imgArray.length;
    let count = useRef(1);

   
    const dotChange = (id) => {
        count.current = id
        console.log(count.current);
        console.log(id);

        const newState = imgArray.map(img => {
            if(img.id === id) {
                console.log(img);
                return {...img, current: "show"}
            }
            if(img.id != id) {
                return {...img, current: "hide"}
            }  
            
            return img;
        })

        setImgArray(newState)
    }

    useEffect(() => {
       setInterval(() => {
         handlePrevious()
       }, 3000);
    }, []);
 
    const updateImgArray = () => {
      
        const newState = imgArray.map(img => {
            if(img.id === count.current) {
                console.log(img);
                return {...img, current: "show"}
            }
            if(img.id != count.current) {
                return {...img, current: "hide"}
            }  
            
            return img;
        })
        setImgArray(newState)
 
        let ctx = gsap.context(() => {
            gsap.to('#img', {
                opacity: 0,
                ease: "Power2.easeInOut",
                duration: 2,
                delay: 1.2
            })
            gsap.to('.show', {
                opacity: 1,
                ease: "Power2.easeInOut",
                duration: 2,
                delay: 1.2
            })
        })
        console.log(imgArray);
    }


    const handlePrevious = async () => {
        
        count.current++
        imgArray.forEach((slide, i) => {
            let ctx = gsap.context(() => {
                gsap.set('.show', {
                    left: 0,
                    duration: 0.2,
                })
                gsap.set('.hide', {
                    left: 25,
                    duration: 0.2,
                })
            })
        })
        
        if(count.current > numSlides) {
               
                count.current = 1
            }    
            updateImgArray()
            console.log(count.current);
    }

    const handleNext = async () => {
    
        count.current--
        if(count.current  <= 0) {
            count.current = numSlides
        }
        updateImgArray()
        console.log(count.current);
    }


  return (
    <div>
        <div className="carousel_container">
            <div className="img_box">
                <div className="img_container">
                  {imgArray.map(img=> {
                    return <img className={img.current} key={uuidv4()} id='img' src={img.src}></img>
                  })}
                </div>
            </div>
            <div className="controllers">
                <div className="left" onClick={handlePrevious}>
                  <TiChevronLeftOutline  />
                </div>
                <div className="right" onClick={handleNext}>
                  <TiChevronRightOutline  />
                </div>
            </div>
            <div className="picsNumber">
                {imgArray.map(img=> {
                    return <div className={img.current + '_dot'} onClick={() => dotChange(img.id)} key={uuidv4()} id='dot'></div>
                  })}
            </div>
        </div>
    </div>
  )
}
